<h1 mat-dialog-title *ngIf="!isBusy" xmlns="http://www.w3.org/1999/html">Edit Event Contact Information</h1>
<div *ngIf="!isBusy; else spinner" class="event-edit-contact__form-container">
  <fieldset class="event-edit-contact__form-section">
    <legend class="event-edit-contact__form-section-title">Event Contact Information</legend>
    <mat-dialog-content [formGroup]="formGroup">
      <mat-form-field class="event-edit-contact__formItem">
        <input matInput
               placeholder="Contact Person Name *"
               formControlName="contactPersonName" [(ngModel)]="aviationEvent.contactPersonName" maxlength="256">
      </mat-form-field>
      <mat-form-field class="event-edit-contact__formItem">
        <input matInput
               placeholder="Contact Person Email *"
               formControlName="contactPersonEmail" [(ngModel)]="aviationEvent.contactPersonEmail" maxlength="256">
      </mat-form-field>
      <mat-form-field class="event-edit-contact__formItem">
        <input matInput
               placeholder="Contact Person Phone *"
               formControlName="contactPersonPhone" [(ngModel)]="aviationEvent.contactPersonPhone" maxlength="256">
      </mat-form-field>
    </mat-dialog-content>
  </fieldset>
  <mat-dialog-actions class="form-formatting">
    <button type="submit" [disabled]="!formGroup.valid" id="saveButton" class="submit-button mat-raised-button" (click)="save()">
      Save
    </button>
    <button id="cancelButton" class="mat-raised-button" (click)="cancel()">Cancel</button>
  </mat-dialog-actions>
</div>
<ng-template #spinner>
  <div class="spinnerContainer">
    <mat-spinner  class="spinner" [diameter]="100" [color]="'accent'"></mat-spinner>
  </div>
</ng-template>
